function addMoveByCursor(toolbar) {
  if (toolbar.querySelector('.tox-toolbar .cus-move-controller')) return
  const divEle = document.createElement('div')
  divEle.title = '点击拖拽'
  divEle.innerHTML = `<svg t="1756278329169" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6661" width="16" height="16"><path d="M279.272727 0h186.181818v186.181818H279.272727zM279.272727 279.272727h186.181818v186.181818H279.272727zM558.545455 0h186.181818v186.181818H558.545455zM558.545455 279.272727h186.181818v186.181818H558.545455zM279.272727 558.545455h186.181818v186.181818H279.272727zM558.545455 558.545455h186.181818v186.181818H558.545455zM279.272727 837.818182h186.181818v186.181818H279.272727zM558.545455 837.818182h186.181818v186.181818H558.545455z" fill="#B1B5BD" p-id="6662"></path></svg>`
  divEle.classList.add('cus-move-controller')
  divEle.onmousedown = function (e) {
    e.stopPropagation()
    e.preventDefault()
    console.log(e)
    const move = event => {
      // eslint-disable-next-line no-param-reassign
      toolbar.style.left = `${event.clientX - toolbar.offsetWidth + 16}px`
      // eslint-disable-next-line no-param-reassign
      toolbar.style.top = `${event.clientY - 16}px`
    }
    const mouseUp = () => {
      window.removeEventListener('mousemove', move)
      window.removeEventListener('mouseup', mouseUp)
    }
    window.addEventListener('mousemove', move)
    window.addEventListener('mouseup', mouseUp)
  }
  toolbar.querySelector('.tox-toolbar').appendChild(divEle)
}

const toolbarFollowPosition = editor => {
  editor.on('click', () => {
    const { selection } = editor
    const range = selection.getRng()
    const toolbar = editor.editorContainer
    if (!toolbar) return

    const clientRect = range.getBoundingClientRect()
    const TOOLBAR_HEIGHT = toolbar.offsetHeight // 直接获取工具栏实际高度
    const VIEWPORT_MARGIN = 20

    // 计算可用空间
    const spaceAbove = clientRect.top + window.scrollY - TOOLBAR_HEIGHT - VIEWPORT_MARGIN
    const spaceBelow = window.innerHeight - clientRect.bottom - TOOLBAR_HEIGHT - VIEWPORT_MARGIN

    toolbar.style.position = 'absolute'
    toolbar.style.maxHeight = '500px'
    addMoveByCursor(toolbar)
    if (spaceAbove > 0) {
      toolbar.style.top = `${clientRect.top + window.scrollY - TOOLBAR_HEIGHT - 5}px` // 增加5px偏移避免完全遮挡
    } else if (spaceBelow > 0) {
      toolbar.style.top = `${clientRect.bottom + window.scrollY + 10}px` // 增加更多下方间距
    } else {
      // 确保最小间距保护光标可见
      const cursorTop = clientRect.top + window.scrollY
      const adjustedTop = Math.min(
        Math.max(cursorTop - TOOLBAR_HEIGHT, window.scrollY + VIEWPORT_MARGIN),
        window.scrollY + window.innerHeight - TOOLBAR_HEIGHT,
      )
      toolbar.style.top = `${adjustedTop}px`
    }
  })
}
export default toolbarFollowPosition
